import { TherapySessionType } from '../../types';

export const isAdvancedNoteType = (noteType: TherapySessionType) => {
    return [
        TherapySessionType.Girp,
        TherapySessionType.Birp,
        TherapySessionType.Emdr,
        TherapySessionType.Mse,
        TherapySessionType.PsychiatricIntake,
        TherapySessionType.PsychiatricSoap,
        TherapySessionType.GpSoap,
        TherapySessionType.HeadwaySoap,
        TherapySessionType.Bps,
    ].includes(noteType);
};
